/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Skeleton } from "@mui/material";

export const StyledStatisticLoader = styled(Skeleton)({
  fontSize: '24px',
  width: '40%',
})
